<template>
  <div>
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">机侧题库</Breadcrumb-item>
        <Breadcrumb-item>升班建议</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search mex-search">
      <Form :show-message="false" label-position="top">
        <Row :gutter="16">
          <i-col :span="12">
            <Form-item label="学生ID">
              <Input v-model="queryParam.uid" placeholder="请输入学生 uid"></Input>
            </Form-item>
          </i-col>
          <i-col :span="12">
            <Form-item label="升班建议">
              <Select v-model="queryParam.promotion" clearable placeholder="请选择升班建议">
                <Option value="UP">直接升班</Option>
                <Option value="CONSOLIDATE">巩固后升</Option>
                <Option value="REMEDIATE">先补核心</Option>
                <Option value="REPEAT">本级重学</Option>
              </Select>
            </Form-item>
          </i-col>
        </Row>
        <div class="mex-search-actions">
          <Button type="primary" @click="search">搜索</Button>
        </div>
      </Form>
    </div>
    <List ref="list" style="margin-top: 10px" :tableColumns="tableColumns" listUrl="/mex/promotions/list"
          :params="queryParam" :onLoading="onLoading" :reload="reload"></List>
  </div>
</template>

<script>
export default {
  name: 'MexPromotionList',
  data () {
    return {
      searchLoading: false,
      reload: 0,
      queryParam: {},
      tableColumns: [
        { title: '场次', key: 'sessionId', width: 90, ellipsis: true },
        { title: '学生ID', key: 'uid', width: 100, ellipsis: true },
        { title: '当前级别', key: 'courseLevel', width: 90, ellipsis: true },
        { title: '场次状态', key: 'status', width: 140, ellipsis: true, render: (h, params) => h('span', this.statusLabel(params.row.status, params.row.publishStatus || params.row.flags)) },
        { title: '总分', key: 'totalScore', width: 80, ellipsis: true },
        { title: '升班建议', key: 'promotion', width: 120, ellipsis: true, render: (h, params) => h('span', this.labelOf(params.row.promotion)) },
        {
          title: '模块分',
          key: 'moduleJson',
          minWidth: 280,
          render: (h, params) => h('span', { style: { whiteSpace: 'normal', lineHeight: '1.4' } }, this.moduleScoreText(params.row.moduleJson))
        },
        { title: '标记', key: 'flags', width: 120, ellipsis: true, render: (h, params) => h('span', this.flagsLabel(params.row.flags)) },
        { title: '时间', key: 'gmtCreate', width: 170, ellipsis: true }
      ]
    }
  },
  methods: {
    onLoading (loading) {
      this.searchLoading = loading
    },
    search () {
      this.reload = Date.now()
      this.$nextTick(() => this.$refs.list && this.$refs.list.search())
    },
    labelOf (code) {
      if (code === 'UP') return '直接升班'
      if (code === 'CONSOLIDATE') return '巩固后升'
      if (code === 'REMEDIATE') return '先补核心'
      if (code === 'REPEAT') return '本级重学'
      return code || ''
    },
    statusLabel (code, publishOrFlags) {
      if (code === 'CREATED') return '已创建'
      if (code === 'CONSENT') return '待同意公约'
      if (code === 'PROFILE') return '信息采集'
      if (code === 'DEV_AUDIO') return '设备调试（音频）'
      if (code === 'DEV_MIC') return '设备调试（麦克风）'
      if (code === 'IN_PROGRESS') return '答题中'
      if (code === 'PAUSED') return '已暂停'
      if (code === 'SCORING') return '评分中'
      if (code === 'READY') return '已交卷'
      if (code === 'COMPLETED') return '已完成'
      if (code === 'ABANDONED') return '已放弃'
      if (code === 'INCOMPLETE_REF') {
        let pub = publishOrFlags || ''
        if (pub === 'REVIEW' || pub === 'PROVISIONAL' || pub === 'BELOW_L1') return '待复核'
        return '作答不足'
      }
      if (code === 'INVALID') return '已作废'
      return code || '—'
    },
    moduleScoreText (raw) {
      let obj = this.parseModule(raw)
      let keys = [
        ['Listening', '听力'],
        ['Speaking', '口语'],
        ['Reading', '阅读'],
        ['Writing', '写作']
      ]
      let parts = []
      for (let i = 0; i < keys.length; i++) {
        let en = keys[i][0]
        if (obj[en] === undefined || obj[en] === null || obj[en] === '') continue
        parts.push(keys[i][1] + ' ' + obj[en])
      }
      return parts.length ? parts.join(' · ') : '—'
    },
    flagsLabel (code) {
      if (code === 'TRIAL') return '试做'
      if (code === 'ABNORMAL_FAST') return '作答过快'
      if (!code) return '—'
      return code
    },
    parseModule (raw) {
      if (!raw) return {}
      if (typeof raw === 'object') return raw
      try {
        return JSON.parse(raw) || {}
      } catch (e) {
        return {}
      }
    }
  }
}
</script>

<style lang="less">
@import './mex-search.less';
</style>



// WEBPACK FOOTER //
// MexPromotionList.vue?7100adea